import React from 'react';
import ReactDom from 'react-dom';

import {observable, action, computed} from 'mobx';
import {observer} from 'mobx-react';

import {deepBind} from 'base-contentmodel';

import BaseComponent from 'base-component';
import BaseContentModel from 'base-contentmodel';

import {InputFieldContentModel} from '../inputFields/contentmodel';
import {LayoutContentModel} from '../layouts/contentmodel';
import {StaticContentModel} from '../static/contentmodel';
import {ButtonContentModel} from '../buttons/contentmodel';

import {ControlGroupComponent, FormComponent} from './component';

export class ControlGroupContentModel extends BaseContentModel {

    static get _slots() {
        return {
            label: "",
            css: "",
            controls: [InputFieldContentModel, ]
        };
    }

    static get _defaults() {
        return {
            label: "",
            css: "",
            controls: []
        };
    }

    Component = ControlGroupComponent;

    @observable
    /* @slot */ label = "";

    @observable
    /* @slot */ css = "";

    @observable.shallow
    /* @slot */ controls = [];
}


export class FormContentModel extends BaseContentModel {

    static get _slots() {
        return {
            title: "",
            css: "",
            controls: [BaseContentModel],
            autoUpdate: true,
            updateAction: "",
            submitAction: "",
        };
    }

    static get _defaults() {
        return {
            label: "",
            css: "",
            autoUpdate: true,
            controls: [InputFieldContentModel, LayoutContentModel, StaticContentModel, ControlGroupContentModel, ButtonContentModel],
            updateAction: "",
            submitAction: "",
        };
    }

    Component = FormComponent;

    @observable
    /* @slot */ label = "";

    @observable
    /* @slot */ css = "";

    @observable.shallow
    /* @slot */ controls = [];

    @observable autoUpdate = true;

    @observable
    /* @slot */ updateAction = "runProformaModel";

    @observable
    /* @slot */ submitAction = "";

    
    @observable isSubmitted = false;
}





export default FormContentModel;



// WEBPACK FOOTER //
// ./app_modules/form-control-activity/forms/contentmodel.js